angular.module('unergie.main')
.directive('salesTunnelBPSpecificsV3', ($uibModal, $filter, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        scope: {
            draft: '=',
            landscape: '=',
            disableContractEdition: '=',
        },
        templateUrl: '/states/salesTunnelV3/component/salesTunnelBPSpecificsV3.html',
        link($scope) {
            $scope.form = {}
            $scope.cachedForm = {}
            $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')

            $scope.CAR_TRESHOLD = {
                LOW: 5,
                HIGH: 10,
            }

            $scope.chechDiff = () => {
                return ($scope.estimatedEuros && Math.abs($scope.estimatedEuros.declared - $scope.estimatedEuros.measure)) || 0
            }

            // VALIDATORS
            const initComponentValidator = () => {
                MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                    isBillingModalityValid(store) {
                        return ['12month', '2month'].includes(store.draft.billing_modality)
                    },
                })
            }

            MetaWatcher.watch('SALES_TUNNEL.UPDATED_CHOOSEN_DATA', 'salesTunnelBPSpecifics', $scope, (newData) => {
                _.assign($scope.cachedForm, newData)
            })

            const initForm = (draft) => {
                _.assign($scope.form, _.pick(draft, [
                    'billing_modality',
                    'id_p_calendar',
                    'choosen_id_p_calendar',
                    'max_power',
                    'choosen_max_power',
                    'preferred_estimator',
                ]))
            }

            $scope.$watch('draft', initForm)

            const activate = function () {
                initComponentValidator()
                initForm($scope.draft)
                _.assign($scope.cachedForm, _.pick($scope.draft.draftElec, [
                    'choosen_id_p_calendar',
                    'choosen_max_power',
                    'choosen_routing_tariff',
                ]))
            }

            $scope.modifiedBillingModality = (data) => {
                $scope.saveDraft(data, true).then(() => {
                    MetaWatcher.notif('SALES_TUNNEL.MODIFIED_BILLING_MODALITY')
                })
            }

            MetaWatcher.watch('SALES_TUNNEL.MODIFIED_ESTIMATED_EUROS', 'salesTunnelBPSpecifics', $scope, (estimators) => {
                $scope.estimatedEuros = estimators
            })

            MetaWatcher.watch('SALES_TUNNEL.MODIFIED_ESTIMATED_CONS', 'salesTunnelBPSpecifics', $scope, (estimators) => {
                $scope.estimatedCons = estimators
            })

            $scope.getDeclaredCons = () => {
                return _.sum(_.values($scope.draft.declared_cons.cons))
            }

            activate()
        },
    })
)
